import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_PROVEEDORES_URL } from "../../constants";

//Componentes bootstrap
import { Form, Col } from "react-bootstrap";

/**
 * Combo del catálogo de Solicitante Real.
 *
 * Props:
 *  - value: id (number|string) del solicitante real seleccionado.
 *  - onChange: callback(id) al seleccionar una opción (no se usa en modo lectura).
 *  - disabled: si true, el combo es de solo consulta.
 *
 * Las opciones se muestran como "Nombre - Email" y el value es el id del catálogo.
 */
function SeleccionarSolicitanteReal(props) {
  const { value, onChange, disabled } = props;
  const [solicitantes, setSolicitantes] = useState([]);

  useEffect(() => {
    axios
      .get(API_PROVEEDORES_URL + "solicitanteReal/getSolicitantesReales")
      .then((res) => {
        if (res.data && res.data.list) {
          setSolicitantes(res.data.list);
        } else {
          setSolicitantes([]);
        }
      })
      .catch((error) => {
        console.log("No se pudo recuperar el catálogo de solicitantes reales", error);
        setSolicitantes([]);
      });
  }, []);

  function handleChange(e) {
    if (onChange) {
      onChange(e.target.value);
    }
  }

  function cargarOpciones() {
    return solicitantes.length
      ? solicitantes.map((s) => (
          <option key={s.id} value={s.id}>
            {s.solicitanteReal} - {s.emailSolicitanteReal}
          </option>
        ))
      : null;
  }

  return (
    <Form.Group as={Col}>
      <Form.Label>Solicitante real</Form.Label>
      <Form.Control
        size="sm"
        id="solicitanteReal"
        type="text"
        as="select"
        required
        disabled={disabled}
        value={value != null ? String(value) : ""}
        onChange={handleChange}
      >
        <option value="">Seleccione solicitante real</option>
        {cargarOpciones()}
      </Form.Control>
    </Form.Group>
  );
}

export default SeleccionarSolicitanteReal;
